<template>
    <div>
        <app-tabela
            idTabela="tblMensRecebidas"
            :itens="mensagens"
            :campos="campos"
            :itensPorPagina="itensPorPagina"
        >
            <template slot="acoes" slot-scope="data">
                <span class="text-primary">
                    <i
                        class="fa fa-info-circle fa-lg icon-button"
                        title="Visualizar"
                        @click.stop="visualizarMensagem(data.mensagemId)"
                    ></i>
                </span>
            </template>
        </app-tabela>
    </div>
</template>

<script>
export default {
	props: {
		mensagens: {
			type: Array,
			default: () => []
		}
	},

	components: {},

	data() {
		return {
			campos: [
				{
					key: 'enviadaPor',
					label: 'De',
					sortable: true,
					filterable: true
				},
				{
					key: 'assunto',
					label: 'Assunto',
					sortable: true,
					filterable: true
				},
				{
					key: 'leituraStatusDescr',
					label: 'Status',
					sortable: true,
					filterable: true,
					type: 'status'
				},
				{
					key: 'dataEnvio',
					label: 'Enviada em',
					sortable: true,
					type: 'datetime'
				},
				{
					key: 'acoes',
					label: 'Ações'
				}
			],
			itensPorPagina: 10
		}
	},

	methods: {
		visualizarMensagem(id) {
			this.$router.push({
				name: 'Mensagens_Detalhar',
				params: {
					mensagemId: id
				}
			})
		}
	},

	created() {},

	computed: {},

	watch: {}
}
</script>
